import { Grid } from '@mui/material';

import styles from 'assets/css/Hypo.module.css';
import SVG from 'assets/img/dash-noData.svg';

export const NoChartData = () => {
  return (
    <Grid
      style={{ padding: '8px 16px 16px' }}
      container
      className={styles.wrapper}
    >
      <Grid xs={12} item className={styles.imgBackHypo}>
        <img src={SVG} />
      </Grid>
      <Grid xs={12} item mb="40px">
        <p className={styles.noDataText}> در این بازه زمانی تست قند خون ثبت نشده است.</p>
      </Grid>
    </Grid>
  );
};
